<div class="menu-container">
  <div *ngFor="let navigationItem of navigationItems" class="menu-card-container">
    <a [routerLink]="[ '/'+navigationItem.path]">
      <div class="menu-card">
        <div class="menu-header" [ngStyle]="{'background-image': 'url('+navigationItem.backgroundImage+')', 'filter': navigationItem.path===undefined ? 'saturate(0)' : ''}">

        </div>
        <div class="menu-footer">
          <div>{{navigationItem.title}}</div>
          <div class="footer-description">{{navigationItem.description}}</div>
        </div>
      </div>
    </a>
  </div>
</div>